import { cx } from "@jugl-web/utils";
import { forwardRef, HTMLProps } from "react";

export const TaskHoverableButton = forwardRef<
  HTMLButtonElement,
  Omit<HTMLProps<HTMLButtonElement>, "type">
>(({ className, ...props }, ref) => (
  <button
    ref={ref}
    type="button"
    className={cx(
      "jugl__focusable-outline flex h-8 cursor-pointer items-center justify-center gap-1.5 rounded-lg border-none bg-grey-200 text-xs text-dark-700 transition-colors duration-300 hover:bg-[#E9ECED]",
      className
    )}
    {...props}
  />
));
